import { FontSizeOutlined } from '@ant-design/icons';
import type { IWidgetType } from '~packages/engine/src/schema/widgets/IWidgetType';
import { tran } from '../../../../translations/schema/TranslationSchema';
import { WidgetCategory, WidgetMainType, WidgetType } from '../../../Widget';
import type { IParagraphWidget } from './IParagraphWidget';
import { ParagraphWidgetComponent } from './ParagraphWidgetComponent';
import {
  ParagraphWidgetConfigComponent,
  ParagraphWidgetConfigSchema,
} from './ParagraphWidgetConfigComponent';

/**
 * Tipo del componente di visualizzazione di un paragrafo.
 */
export const ParagraphWidgetType: IWidgetType<IParagraphWidget> = {
  icon: <FontSizeOutlined />,
  type: WidgetType.Paragraph,
  mainType: WidgetMainType.Graphic,
  category: WidgetCategory.Graphic,
  name: 'Paragrafo',
  hasValue: false,
  formComponent: ParagraphWidgetComponent,
  configComponent: ParagraphWidgetConfigComponent,
  configValidator: ParagraphWidgetConfigSchema,
  previewComponent: ParagraphWidgetComponent,
  translationSchema: tran.widget({
    helpText: tran.rte(),
    body: tran.rte(),
  }),
  rules: [],
};
